module.exports = __webpack_public_path__ + "215c93e5aaf7823daad58fa35efba19d.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/carolyn-stransky.jpg
// module id = 435
// module chunks = 0